import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useFormCompletion } from '../Context/FormCompletionContext';
import { ShopContext } from '../Context/ShopContext';

const ConfirmationForm = () => {
    const databaseUrl = process.env.REACT_APP_DATABASE_URL;
    const { markFormAsCompleted, saveFormData, formData } = useFormCompletion();
    const [total, setTotal] = useState(0);
    const {
        cartItems,
        selectedItems,
        setSelectedItems,
        removeSelectedItemsFromCart,
      } = useContext(ShopContext);
      const navigate = useNavigate();
      const [newFormData, setNewFormData] = useState({
        num_purchase_products: 0,
        products: selectedItems,
        total: 0,
      });

      const [selectedProducts, setSelectedProducts] = useState({});
      const [isSubmitting, setIsSubmitting] = useState(false);
      
    useEffect(() => {
        const fetchProducts = async () => {
        const fetchedProducts = {};
        for (const item of selectedItems) {
            try {
            const response = await fetch(
                `${databaseUrl}/product/${item.product_id}`
            );
            const data = await response.json();
            if (data.success) {
                fetchedProducts[item.product_id] = data.product;
            } else {
                console.error(
                `Failed to fetch product ${item.product_id}:`,
                data.message
                );
            }
            } catch (error) {
            console.error(`Error fetching product ${item.product_id}:`, error);
            }
        }
        setSelectedProducts(fetchedProducts); // Store fetched products in state
        };
    
        if (selectedItems.length > 0) {
        fetchProducts();
        }
    }, [selectedItems]);
    
    // Update form data when selected products or cart items change
    useEffect(() => {
        if (Object.keys(selectedProducts).length > 0) {
        const productArray = Object.values(selectedProducts); // Convert object to array
        const product_ids = productArray.map((product) => product.id);
        const productnames = productArray.map((product) => product.name);
    
        // Calculate total and number of purchased products
        let total = 0;
        let num_purchase_products = 0;
    
        selectedItems.forEach((item) => {
            const quantity = item.quantity || 0;
            const itemInfo = productArray.find(
            (product) => product.id === item.product_id
            );
            if (itemInfo) {
            total += itemInfo.new_price * item.quantity;
            }
            num_purchase_products += quantity;
        });
        setTotal(total);
        // Update form data
        setNewFormData((prevData) => ({
            ...prevData,
            product_ids,
            productnames,
            total,
            num_purchase_products,
        }));
        }
    }, [selectedProducts, cartItems]);
    
      const handleChange = (event) => {
        const { name, value } = event.target;
        setNewFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
        }));
      };
    
      useEffect(() => {
        if (formData.confirm_details) {
          const savedData = formData.confirm_details;
          setNewFormData((prevFormData) => ({
            ...prevFormData,
            ...savedData,
          }));
        }
      }, [formData.confirm_details]);
    
      const onSubmit = (event) => {
        event.preventDefault();
        console.log(newFormData);
        setIsSubmitting(true);
        saveFormData("confirm_details", newFormData);
        Add_Order();
      };

      const Add_Order = async () => {
        console.log(formData);

        const orderData = {
            ...formData.customer_details,
            ...formData.delivery_details,
            products: selectedItems,
            total: newFormData.total,
          };
    
        // Uncomment to enable POST request for adding the order
        try {
          const response = await fetch(`${databaseUrl}/orderconfirmation`, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(orderData),
          });
    
          const data = await response.json();
    
          if (data.success) {
            setSelectedItems([]);
            removeSelectedItemsFromCart();
            navigate("/thanks");
          } else {
            alert("Failed to add the order. Please try again later.");
          }
        } catch (error) {
          console.error("Error adding order:", error);
          alert(
            "An error occurred while processing your order. Please try again later."
          );
        } finally {
          setIsSubmitting(false);
        }
      };

  return (
    <div className="sm:p-4 md:pr-10 rounded-lg">
      <h2 className="text-xl font-semibold text-[#551E19] mb-4">Order Confirmation</h2>
      <div className="space-y-0 border-2 border-gray-300 p-3 sm:p-4 md:p-6 rounded-3xl overflow-hidden">
        <p className='font-semibold'> {formData.customer_details?.firstName} {formData.customer_details?.lastName}</p>
        <p className='text-sm'>{formData.customer_details?.email}</p>
        <p className='text-sm'>{formData.customer_details?.phoneNumber}</p>
        <p className='text-sm pt-5'>
          {formData.delivery_details?.houseNumber},<br /> 
          {formData.delivery_details?.addressLine1}, {formData.delivery_details?.addressLine2},<br />
          {formData.delivery_details?.city},<br /> 
          {formData.delivery_details?.district}, {formData.delivery_details?.province}
        </p>
        <p className='font-semibold pt-5'>Payment method: </p>
        <p className='text-sm'>Cash on delivery (default)</p>
      </div>
      <div className="flex flex-col xs:flex-row gap-4 justify-between items-center mt-4 md:px-6">
        <p ><span className='font-semibold'>Total:</span> Rs.{total}</p>
        <button className="bg-[#E6B17E] text-white px-5 py-2 rounded-full" disabled={isSubmitting} onClick={onSubmit}>
          {isSubmitting ? 'Submitting...' : 'PLACE ORDER'}
        </button>
      </div>
    </div>
  )
}

export default ConfirmationForm
